
export const Mean = (dataPoints: number[]): number => {
  const mean: number = dataPoints.reduce((sum, value) => sum + value, 0) / dataPoints.length;
  return mean;
};


export const StandardError = (dataPoints: number[]): number => {
  // Step 1: Calculate the Mean
  const mean: number = Mean(dataPoints);

  // Step 2: Calculate the Differences
  const differences: number[] = dataPoints.map(value => value - mean);

  // Step 3: Square the Differences
  const squaredDifferences: number[] = differences.map(diff => diff * diff);

  // Step 4: Calculate the Variance
  const variance: number = squaredDifferences.reduce((sum, squaredDiff) => sum + squaredDiff, 0) / dataPoints.length;

  // Step 5: Calculate the Standard Error
  const standardError: number = Math.sqrt(variance) / Math.sqrt(dataPoints.length);

  return standardError;
};